import { Dialog } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledDialog = styled(Dialog)(({ theme }) => ({
  '&.CEcontainer': {
    '.MuiDialog-paper': {
      borderRadius: theme.spacing(1),
      color: theme.palette.secondary.contrastText,
      maxWidth: theme.spacing(112.5),
      [theme.breakpoints.down('md')]: {
        width: '100%',
        height: '100%',
        maxHeight: '100%',
        margin: 0,
        borderRadius: 0,
      },
    },
    '.MuiDialogContent-root': {
      padding: 0,
      backgroundColor: theme.palette.background.secondary,
      [theme.breakpoints.up('lg')]: {
        overflowY: 'hidden',
      },
    },

    '& .CEcloseBtn': {
      position: 'absolute',
      right: theme.spacing(1.25),
      top: theme.spacing(1.25),
      '& svg': {
        color: theme.palette.common.white,
      },
    },
    '& .CEcontentContainer': {
      padding: theme.spacing(8),
      [theme.breakpoints.down('md')]: {
        padding: theme.spacing(6, 3),
      },
    },
    '& .CEOContent': {
      padding: '0',
      '& .CEOText': {
        color: theme.palette.text.secondary,
      },
      '& .CEOAction': {
        minWidth: theme.spacing(21.25),
        [theme.breakpoints.down('md')]: {
          width: '100%',
        },
      },
      '& .CEOLink': {
        color: theme.palette.text.primary,
        fontWeight: '700',
      },
    },
    '& .grecaptcha-badge': {
      visibility: 'hidden',
    },

    '& .CEimage': {
      width: '100%',
      height: '100%',
      overflow: 'hidden',
    },
  },
}));

export default StyledDialog;
